import styled from 'styled-components';

const SidebarHeader = styled.nav`
  min-height: 50px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
`;

const Row = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
`;
const OptionContainer = styled.div`
  margin-top: 17px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const OptionBox = styled.div`
  display: flex;
  width: 50%;
  flex-direction: row;
  color: '#fff';
  margin-bottom: 10px;

  &:hover {
    cursor: pointer;
  }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 17px;
  margin: 0;
  transform: translateY(-2px);
  font-weight: 400;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 1;
`;

const Divider = styled.div`
  width: 80%;
  height: 1px;
  margin-right: 1px;
  background-color: #f1f1f1;
  opacity: 0.7;
  align-self: center;
  margin-bottom: 15px;
`;

export { SidebarHeader, Divider, Row, OptionContainer, OptionBox, Title };
